import { Suspense, useState, useEffect } from "react";
import BullCardFilter from "./filter";
import AppLoading from "../../app-loading/app-loading";
import BullCard from "./card";
import "./empty-state.css";
import oilProductionService from "../../../services/oilProduction/oilProductionservice";

const BullCards: React.FC = () => {
  const [bullCardList, setBullCardList] = useState<any[] | []>([]);
  const [loading, setLoading] = useState(false);

  const fetchBullStatisticsSummaryData = async (data: any) => {
    try {
      setLoading(true);
      const bcLIst = await oilProductionService.getBullStatisticsSummaryAsync(
        data.manufacturingUnitId,
        data.month,
        data.year,
        data.bullId
      );
      setBullCardList(bcLIst);
    } catch (err) {
      setBullCardList([]);
      console.error("Error fetching bull work statistics data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = async (data: any) => {
    await fetchBullStatisticsSummaryData(data);
  };

  const handleReset = async () => {
    setBullCardList([]);
    scrollToBottom();
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth"
    });
  };

  return (
    <Suspense fallback={<AppLoading />}>
      <div className="bull-dashboard-wrapper">
        <div className="bull-dashboard-header">
          <div className="flex align-items-center gap-3 mb-3">
            <div className="bull-header-icon-wrapper">
              <i className="pi pi-chart-pie text-white text-4xl"></i>
            </div>
            <div>
              <h1 className="bull-header-title">Bull Statistics</h1>
              <p className="bull-header-subtitle">
                Monitor bull performance, batch completion, and operator
                efficiency
              </p>
            </div>
          </div>
        </div>
        <div style={{ marginBottom: "2rem" }}>
          <BullCardFilter onFilter={handleFilter} onReset={handleReset} />
        </div>
        <div className="cards-container">
          {bullCardList && bullCardList.length > 0 ? (
            bullCardList.map((card, index) => (
              <BullCard key={index} bullcard={card} />
            ))
          ) : (
            <div className="empty-state-container">
              <div className="empty-state-content">
                <div className="empty-state-icon-wrapper">
                  <i className="pi pi-chart-pie text-6xl"></i>
                </div>
                <h3 className="empty-state-title">No Records Found</h3>
                <p className="empty-state-message">
                  No bull data available at the moment. Please try adjusting
                  your filters or check back later.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      {loading && <AppLoading />}
    </Suspense>
  );
};

export default BullCards;
